function Private() {
  return (
    <div>
      <h1>Private</h1>
      <p>Only you can see this.</p>
    </div>
  );
}

export default Private;